import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-tooltip/dist/react-tooltip.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from './Redux/Store';
import AppRouter from './Router/AppRouter';
import { ThemeProvider } from 'styled-components';
import { appTheme } from './Library/Theme';
import { registerLocale } from 'react-datepicker';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import de from 'date-fns/locale/de';
import es from 'date-fns/locale/es';
import en from 'date-fns/locale/en-GB';
import { PersistGate } from 'redux-persist/integration/react';

// @ts-ignore
registerLocale('de-DE', de);
// @ts-ignore
registerLocale('es-ES', es);
// @ts-ignore
registerLocale('en-US', en);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={appTheme}>
          <AppRouter />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
